export const getAllDocumentsAction = (data) => {
    return {
        type: "GET_ALL_DOCUMENTS",
        payload:data,
    };
};
